<div id="product-description-classification-wrapper">
  <div
    [class.hide-unique]="!showUniqueSelling"
    [class.hide-desc]="!showProdDesc"
    class="container"
    id="product-description-classification"
    [ngClass]="activeLanguage$ | async"
  >
    <div id="product-left">
      @if (showUniqueSelling) {
      <h2>{{ 'product.productOptions.uniqueSellingPoints.title' | cxTranslate }}</h2>
      <section [innerHTML]="clasificationResult"></section>
      }
    </div>
    <div id="product-right">
      @if (showProdDesc) {
      <div id="product-right-inner-wrapper">
        <h2>{{ 'product.productOptions.productDescription.title' | cxTranslate }}</h2>
        <div>
          <span [innerHTML]="descriptionResult?.message"></span>&nbsp; @if (descriptionResult?.showButton) {
          <a class="read-more-less" (click)="loadDescriptionisClicked()">
            {{ descriptionResult.showButtonMessage }}
          </a>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>

@if (logisticsTrigger && logisticInfo$ | async; as logist) { @if (hasLogisticInfo(logist)) {
<mat-expansion-panel class="product-descr-panel">
  <mat-expansion-panel-header class="pdp-logist-panel-header">
    <mat-panel-title #matPanelClick class="pdp-logist-label">
      {{ 'fish.logisticInfo.title' | cxTranslate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-container class="logisticDescr">
    @if (logist?.logisticWeightNettGram) {
    <div class="feature-wrapper">
      <div>{{ 'fish.logisticInfoLabels.weightNettgram' | cxTranslate }}</div>
      <div>{{ logist?.logisticWeightNettGram }}</div>
    </div>
    } @if (logist?.logisticWeightGrossGram) {
    <div class="feature-wrapper">
      <div>{{ 'fish.logisticInfoLabels.LogisticWeightGrossgram' | cxTranslate }}</div>
      <div>{{ logist?.logisticWeightGrossGram }}</div>
    </div>
    } @if (logist?.logisticDimensionLength) {
    <div class="feature-wrapper">
      <div>{{ 'fish.logisticInfoLabels.LogisticDimensionLength' | cxTranslate }}</div>
      <div>{{ logist?.logisticDimensionLength }}</div>
    </div>
    } @if (logist?.logisticHeight) {
    <div class="feature-wrapper">
      <div>{{ 'fish.logisticInfoLabels.height' | cxTranslate }}</div>
      <div>{{ logist?.logisticHeight }}</div>
    </div>
    } @if (logist?.logisticWidth) {
    <div class="feature-wrapper">
      <div>{{ 'fish.logisticInfoLabels.Width' | cxTranslate }}</div>
      <div>{{ logist?.logisticWidth }}</div>
    </div>
    }
  </ng-container>
</mat-expansion-panel>
} } @if (specifications$ | async; as specs) { @if (specs.classifications; as spec) {
<mat-expansion-panel
  class="product-descr-panel"
  [class.removeBorderTop]="logisticsTrigger && hasLogistInfo"
  [ngClass]="activeLanguage$ | async"
>
  <mat-expansion-panel-header class="pdp-specs-panel-header">
    <mat-panel-title #matPanelClick class="pdp-specs-label">
      {{ 'product.productOptions.productSpecification.title' | cxTranslate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  @for (item of spec; track item) { @for (data of item.features; track data) {
  <div class="feature-wrapper">
    <div>{{ data?.name }}</div>
    <div [innerHTML]="(data?.featureValues)[0].value"></div>
  </div>
  } }
</mat-expansion-panel>
} }
